module.exports = __webpack_public_path__ + "img/fronius-inverter-md.071c059f.svg";